"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

require("slick-carousel/slick/slick.css");

require("../styles/_carousel.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function PreviousArrow(_ref) {
  var onClick = _ref.onClick,
      className = _ref.className;
  return (/*#__PURE__*/_react.default.createElement("div", {
      onClick: onClick,
      className: (0, _classnames.default)('carousel__left-arrow', className),
      role: "button",
      tabIndex: 0,
      onKeyPress: (0, _onEnterPressed.default)({
        onClick: onClick
      })
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
      name: "chevronleft",
      color: "white",
      size: 50
    }))
  );
}

function NextArrow(_ref2) {
  var onClick = _ref2.onClick,
      className = _ref2.className;
  return (/*#__PURE__*/_react.default.createElement("div", {
      onClick: onClick,
      className: (0, _classnames.default)('carousel__right-arrow', className),
      role: "button",
      tabIndex: 0,
      onKeyPress: (0, _onEnterPressed.default)({
        onClick: onClick
      })
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
      name: "chevronright",
      color: "white",
      size: 50
    }))
  );
}

var CAROUSEL_CONFIG = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  prevArrow: /*#__PURE__*/_react.default.createElement(PreviousArrow, null),
  nextArrow: /*#__PURE__*/_react.default.createElement(NextArrow, null),
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  }, {
    breakpoint: 640,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
};

function Carousel(_ref3) {
  var children = _ref3.children;

  if (!children || !Array.isArray(children) || children.length === 1) {
    return children;
  }

  return (/*#__PURE__*/_react.default.createElement(_reactSlick.default, CAROUSEL_CONFIG, children)
  );
}

var _default = (0, _react.memo)(Carousel);

exports.default = _default;